import React, { useEffect, useLayoutEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import ProfitAndLossComponent from "./ProfitAndLossComponent";
import di from "../PNLReports/di/servicelocator";
import DeviceContext from "../../../utils/indentifyDevice";
import { useSelector } from "react-redux";
import { getQueryParameterName } from "../../../utils/urlHelper";
import { IPNLSubTabs, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { EDurationType, getFinancialYear, getFYdateRange, getThisMonthDateRange, } from "@domains/utils/reportDates";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { GTMService } from "@di";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { Dashboard } from "../Dashboard/Dashboard";
import { pnlFilterAssetTabs, reportsTabAndDropDownData, } from "../CommonComponent/constant";
import { ERports } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
import FamilyTaggingMain from "@frameworks/web/components/Reports/FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
import { getPNLSubHeadingName } from "./constant";
import _ from "underscore";
const ProfitAndLossReport = (props) => {
    const device = DeviceContext();
    const isInitLoad = JSON.parse(sessionStorage.getItem("initialLoad")) === true;
    const tabName = getQueryParameterName("tab");
    const reportName = getQueryParameterName("reportName");
    const fromDate = getQueryParameterName("fromDate");
    const toDate = getQueryParameterName("toDate");
    const duration = getQueryParameterName("durationType");
    const qureyAssetType = getQueryParameterName("assetType");
    const pnlDashboardSummary = useSelector((state) => state.dashboardSummary.pnlReport.summary);
    const isSummarize = useSelector((state) => state.pnlReport.data.IsSummarize);
    const showShimmer = useSelector((state) => state.pnlReport.showShimmer);
    const PNLStreamFromStore = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.stream; }, _.isEqual);
    const [selectOption, setSelectedOption] = React.useState();
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [IsSummarize, setIsSummarize] = React.useState(isSummarize);
    const [assetTypeOnGoBack, setAssetTypeOnGoBack] = useState(null);
    const [, setSearchParams] = useSearchParams();
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const PNLDashboard = useSelector((state) => state.dashboardSummary.pnlReport);
    const filters = useSelector((state) => { var _a, _b; return (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FilterData; });
    const determineInitialDates = () => {
        let dates = {
            fromDate: new Date(),
            toDate: new Date(),
            duration: EDurationType.CY,
        };
        if (props.tabKey === IPNLSubTabs.DERIVATIVE) {
            const { startDate, endDate } = getThisMonthDateRange();
            dates.duration = EDurationType.CM;
            dates.fromDate = startDate;
            dates.toDate = endDate;
        }
        else {
            const { startDate, endDate } = getFYdateRange();
            dates.duration = EDurationType.CY;
            dates.fromDate = startDate.toDate();
            dates.toDate = endDate.toDate();
        }
        handlePNLDates(dates.duration, dates.fromDate, dates.toDate);
    };
    const handlePNLDates = (durType, fromDate, toDate) => {
        setSearchParams({
            reportName: "ProfitandLoss",
            durationType: durType,
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
        });
    };
    const onSelect = (akey) => {
        props.setTabKey(akey);
        di.pnlReport.saveProdAssetDropDown(null);
        setAssetTypeOnGoBack(null);
        di.pnlReport.viewTransactionClickScrollerPosition = 0;
        di.pnlReport.LThreeWindowbackClick = false;
        let pnlSubTab = getPNLSubHeadingName(akey);
        props.tabKey === IPNLSubTabs.OTHERS
            ? GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.PNL, ReportsGTMConstants.NewReports, `${pnlSubTab} | Real State`))
            : GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.PNL, ReportsGTMConstants.NewReports, `${pnlSubTab}`));
    };
    const initLoadSet = () => {
        if (!di.pnlReport.LThreeWindowbackClick)
            sessionStorage.setItem("initialLoad", "true");
    };
    React.useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = familyDi === null || familyDi === void 0 ? void 0 : familyDi.familyTagging) === null || _a === void 0 ? void 0 : _a.setStopFamilyAPICall(true);
        }, 0);
        di.pnlReport.getPNLUnderstandingSectionData();
        window.addEventListener("load", initLoadSet);
        return () => {
            window.removeEventListener("load", initLoadSet);
        };
    }, []);
    useEffect(() => {
        setSelectedOption(getPNLSubHeadingName(props.tabKey));
    }, [props.tabKey]);
    const handleScroll = () => {
        (device === null || device === void 0 ? void 0 : device.isMobile) ? setScrollPosition(window.scrollY) : "";
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            di.pnlReport.pnlToggleStream(false);
        };
    }, []);
    React.useEffect(() => {
        if (fromDate &&
            toDate &&
            duration &&
            selectOption &&
            (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)) {
            const getPnlData = async () => {
                const payload = {
                    fromDate,
                    toDate,
                    assetType: assetTypeOnGoBack
                        ? assetTypeOnGoBack
                        : reportsTabAndDropDownData[selectOption].assetProductList[0]
                            .value,
                    duration: duration,
                };
                payload.accountIds = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                if ((props === null || props === void 0 ? void 0 : props.tabKey) === IPNLSubTabs.ALL) {
                    di.pnlReport.getDashboardData({
                        fromDate: fromDate,
                        toDate: toDate,
                        isFamily: (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) !== myAccCode,
                        accountIds: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
                        duration: duration,
                    });
                }
                else if (!di.pnlReport.LThreeWindowbackClick)
                    di.pnlReport.getPNLReportData(payload);
            };
            getPnlData();
        }
    }, [
        selectOption,
        fromDate,
        toDate,
        duration,
        reportName,
        assetTypeOnGoBack,
        selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
    ]);
    useEffect(() => {
        setIsSummarize(isSummarize);
    }, [isSummarize]);
    useEffect(() => {
        if (!showShimmer) {
            setTimeout(() => {
                window.scroll({
                    top: di.pnlReport.viewTransactionClickScrollerPosition,
                    behavior: "auto",
                });
            }, 0);
        }
    }, [showShimmer]);
    useEffect(() => {
        if (isInitLoad && !di.pnlReport.LThreeWindowbackClick)
            determineInitialDates();
    }, [props.tabKey, isInitLoad]);
    useLayoutEffect(() => {
        if (tabName)
            props.setTabKey(tabName);
    }, [tabName]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tabs_pnl  tabs-holding" },
            props.tabKey !== IPNLSubTabs.ALL && (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "w-100 d-flex justify-content-end" },
                React.createElement("div", { className: "family-tagging-holding", id: "family-tagging-holding" },
                    React.createElement(FamilyTaggingMain, { hideConsolidated: true })))),
            React.createElement(Tabs, { defaultActiveKey: tabName ? tabName : props.tabKey, onSelect: onSelect, className: `pnl_tabs ${(device === null || device === void 0 ? void 0 : device.isMobile) && scrollPosition > 100 ? "dock_tabs_mobile" : ""}`, style: (device === null || device === void 0 ? void 0 : device.isMobile) && scrollPosition > 100 ? { top: "63px" } : null },
                React.createElement(Tab, { eventKey: IPNLSubTabs.ALL, title: "All", id: "PnlAll" }, props.tabKey === IPNLSubTabs.ALL && (React.createElement("div", { id: "dashboard" },
                    React.createElement(Dashboard, { isRealisedGainPresent: true, summary: pnlDashboardSummary, reportName: ERports.PNL, setSummary: (isSummarize) => di.pnlReport.getSummarizePNLReportData(isSummarize, getPNLSubHeadingName(props.tabKey)), enableSummary: isSummarize, getDashboardData: (fromDate, toDate, isFamily, accountIds) => { }, showStreamOption: true, streamClickDisabled: PNLDashboard.loader || PNLDashboard.data.length < 1, stream: PNLStreamFromStore, setStream: (stream) => {
                            di.pnlReport.pnlToggleStream(stream);
                        } })))),
                pnlFilterAssetTabs.map((tab) => {
                    return (React.createElement(Tab, { eventKey: tab.eventKey, title: tab.title, id: tab.id }, (tab.eventKey === props.tabKey ||
                        tab.eventKey === tabName) && (React.createElement(ProfitAndLossComponent, { tabKey: tab.eventKey, selectedAssetType: qureyAssetType, startDate: new Date(fromDate), endDate: new Date(toDate), durationType: duration, finYear: finYear, setFinYear: setFinYear, tabName: props.tabKey, loader: props.loader, setLoader: props.setLoader, assetFilter: tab.assetFilter, setAssetTypeOnGoBack: setAssetTypeOnGoBack, isSummarize: IsSummarize, setIsSummarize: setIsSummarize, tillDateSelected: props.tillDateSelected, setTillDateSelected: props.setTillDateSelected, handlePNLDates: handlePNLDates }))));
                })))));
};
export default ProfitAndLossReport;
